import React, { Dispatch, useContext } from 'react';
import { useReducer } from 'react';
import selectedSetReducer, { SelectedSetContextState, SelectedSetAction } from './reducer';

interface AppSelectedSetContext {
  selectedSetState: SelectedSetContextState;
  dispatchSelectedSet: Dispatch<SelectedSetAction>;
}

const defaultState: SelectedSetContextState = {
  selectedSet: null,
  selectedTrayIndex: null,
  selectedVideoIndex: null,
};

const SelectedSetContext = React.createContext<AppSelectedSetContext | undefined>(undefined);
SelectedSetContext.displayName = 'SelectedSet';

const SelectedSetProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [selectedSetState, dispatchSelectedSet] = useReducer(selectedSetReducer, defaultState);
  const value = { selectedSetState, dispatchSelectedSet };

  return <SelectedSetContext.Provider value={value}>{children}</SelectedSetContext.Provider>;
};

const useSelectedSet = (): AppSelectedSetContext => {
  const context = useContext(SelectedSetContext);

  if (context === undefined) {
    throw new Error('useSelectedSet must be used within a SelectedSetProvider');
  }

  return context;
};

export { SelectedSetProvider, useSelectedSet };
